module.exports = __webpack_public_path__ + "img/1.b385acc3.jpg";